export const cabinTextsCZ: { [shipCode: string]: string } = {
  // MSC
  IB: 'Kajuta vnitřní',
  IS: 'Kajuta vnitřní jednolůžková',
  BB: 'Kajuta s balkonem',
  OB: 'Kajuta s oknem',
  OL2: 'Kajuta s oknem premium',
  VL1: 'Kajuta s otevíratelným panoramatickým oknem',
  Il1: 'Kajuta vnitřní premium',
  PV: 'Kajuta s balkonem výhledem na promenádu ',
  SR1: 'Apartmán Junior',
  BS: 'Kajuta s balkonem pro jednotlivce',
  SL1: 'Apartmán premium',
  SX: 'Grand apartmán s vířivkou a terasou',
  SXT: 'Grand apartmán s terasou',
  YIN: 'MSC Yacht Club vnitřní kajuta',
  YC3: 'MSC Yacht Club - Královský apartmán s vířivkou a terasou',
  YCT: 'MSC Yacht Club - Executive a rodinné apartmá s balkonem',
  YCD: 'MSC Yacht Club Duplex Apartmán',
  YJD: 'MSC Yacht Club Duplex Apartmán s terasou a vířivkou',
  YCP: 'MSC Yacht Club Deluxe apartmán s balkonem',
  SLJ: 'Apartmán premium s vířivkou a terasou ',
  YC2: 'MSC Yacht Club - Executive a rodinné apartmá',
  SLW: 'Apartmán premium s vířivkou a terasou ',
  SD: 'Grand Apartmá se dvěma ložnicemi',
  // Costa
  E1: 'Kajuta s výhledem na moře (1. kategorie)',
  S: 'Apartmán',
  B1: 'Kajuta s balkonem (1. kategorie)',
  I1: 'Vnitřní kajuta (1. kategorie)',
};
export const cabinTextsSK: { [shipCode: string]: string } = {
  // MSC
  IB: 'Kajuta vnútorná',
  IS: 'Kajuta vnútorná jednolôžková',
  BB: 'Kajuta s balkónom',
  OB: 'Kajuta s oknom',
  OL2: 'Kajuta s oknom premium',
  VL1: 'Kajuta s otvárateľným panoramatickým oknom',
  Il1: 'Kajuta vnútorné premium',
  PV: 'Kajuta s balkónom výhľadom na promenádu',
  SR1: 'Apartmán Junior',
  BS: 'Kajuta s balkónom pre jednotlivcov',
  SL1: 'Apartmán premium',
  SX: 'Grand apartmán s vírivkou a terasou',
  SXT: 'Grand apartmán s terasou',
  YIN: 'MSC Yacht Club vnútorná kajuta',
  YC3: 'MSC Yacht Club - Kráľovský apartmán s vírivkou a terasou',
  YCT: 'MSC Yacht Club - Executive a rodinný apartmán s balkónom',
  YCD: 'MSC Yacht Club Duplex Apartmán',
  YJD: 'MSC Yacht Club Duplex Apartmán s terasou a vírivkou',
  YCP: 'MSC Yacht Club Deluxe apartmán s balkónom',
  SLJ: 'Apartmán premium s vírivkou a terasou ',
  YC2: 'MSC Yacht Club - Executive a rodinný apartmán',
  SLW: 'Apartmán premium s vírivkou a terasou ',
  SD: 'Grand Apartmán s dvoma spálňami',
  // Costa
  E1: 'Kajuta s výhľadom na more (1. kategória)',
  S: 'Apartmán',
  B1: 'Kajuta s balkónom (1. kategória)',
  I1: 'Vnútorná kajuta (1. kategória)',
};
